import { DateTime } from "luxon";

export class StringUtility {

    static toPossessiveName(s: string) {
        const APOSTROPHE_CHAR = '\'';
        const lastChar = s.slice(-1);
        const endOfWord = lastChar.toLowerCase() == 's' ? APOSTROPHE_CHAR : `${APOSTROPHE_CHAR}s`;
        return `${s}${endOfWord}`;
    }

    static SanitizeString = (val: string | undefined | null): string | undefined =>
        (val === undefined || val === null || val === "") ? undefined : val;

    static SanitizeStringWithEmpty = (val: string | undefined | null): string | undefined =>
        (val === undefined || val === null) ? undefined : val;


    static SanitizeNumber = (val: number | undefined | null): number | undefined =>
        (val === undefined || val === null || isNaN(val)) ? undefined : val;

    static SanitizeDateTimeISO = (val: string | undefined | null): DateTime | undefined =>
        (val === undefined || val === null || val === "") ? undefined : DateTime.fromISO(val);

    static SanitizeDateTimeISOAsUtc = (val: string | undefined | null): DateTime | undefined =>
        (val === undefined || val === null || val === "") ? undefined : DateTime.fromISO(val, { zone: 'UTC' });

    static SanitizeBool = (val: boolean | null | undefined): boolean | undefined =>
        (val === undefined || val === null) ? undefined : val;

    static hasValue = (val: string | undefined | null) =>
        val !== null && val !== undefined && val.trim() !== ""

    static getFullName = ({ firstName, lastName }: { firstName: string | undefined, lastName: string | undefined }) => {
        if (firstName && lastName) {
            return `${firstName} ${lastName}`
        }
        return ''
    }
    static formattedUserName = (first: string | undefined, last: string | undefined, title: string | undefined) =>
        `${title ? title + " " : ""}${first} ${last}`

    static extractNumberFromPxStyle = (pxStyle: string): number | null => {
        const numberRegex = /(\d+(\.\d+)?)\s*px/;
        const match = pxStyle.match(numberRegex);

        if (match === null) {
            return null;
        }

        return parseFloat(match[1]);
    }
    static buildSentenceFromList = (list: string[] | undefined, normalSeparator: string = ", ", finalSeparator: string = " and "): string => {
        if (!list || list.length === 0) {
          return "";
        }
    
        const listLength = list.length;
        const lastItem = list[listLength - 1];
        const result =
          list.slice(0, listLength - 1).join(normalSeparator) +
          (listLength <= 1 ? "" : finalSeparator) +
          lastItem;
    
        return result;
      };
}
